import { AxiosInstance } from 'axios';

export interface CompanyBranding {
    id: string;
    name: string;
    logoUrl?: string;
    primaryColour?: string;
    secondaryColour?: string;
    mode?: string;
    subdomainSlug?: string;
    customDomain?: string;
    allowSubdomainLogin: boolean;
    subdomainLoginHeadline?: string;
    subdomainLoginDescription?: string;
}

export class BrandingService {
    private apiClient: AxiosInstance;

    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
    }

    /**
     * Get company branding by unique key for embedded widgets
     */
    async getCompanyBrandingByUniqueKey(uniqueKey: string): Promise<CompanyBranding> {
        try {
            const response = await this.apiClient.get(`/public/embed/${uniqueKey}/branding`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    /**
     * Get company branding by subdomain (public endpoint)
     */
    async getCompanyBrandingBySubdomain(subdomain: string): Promise<CompanyBranding> {
        try {
            const response = await this.apiClient.get(`/admin/company/public/subdomain/${subdomain}`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    /**
     * Get company logo SAS URL by subdomain (public endpoint)
     */
    async getCompanyLogoBySubdomain(subdomain: string): Promise<string | null> {
        try {
            const response = await this.apiClient.get(`/admin/company/public/subdomain/${subdomain}/logo`);
            return response.data || null;
        } catch (error: any) {
            // Logo is optional, so 404 is not an error
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    }
}
